import React from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';

import {
  initialValues,
  validationSchema,
} from '../../../../../../forms/transactionForm';
import TransactionPresenter from '../../../../../../presenters/TransactionPresenter';
import CashbackPresenter from '../../../../../../presenters/CashbackPresenter';
import StorePresenter from '../../../../../../presenters/StorePresenter';
import Modal from '../../../../../../components/Modal';
import Button from '../../../../../../components/Button';

import EditTransactionForm from './components/EditTransactionForm';

const EditTransactionModal = (props) => {
  const {
    transaction,
    cashback,
    stores,
    isOpen,
    onClose,
    onTransactionUpdate,
  } = props;

  const formik = useFormik({
    initialValues: initialValues(transaction),
    onSubmit: onTransactionUpdate,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
  });

  const { handleSubmit, setFieldValue, values, errors } = formik;

  const handleChange = ({ target }) => {
    const { id, value } = target;

    setFieldValue(id, value);
  };

  return (
    <Modal title="Edit Transaction" onClose={onClose} isModalOpen={isOpen}>
      <form onSubmit={handleSubmit}>
        <EditTransactionForm
          values={values}
          onChange={handleChange}
          stores={stores}
          cashback={cashback}
          errors={errors}
          transaction={transaction}
        />
        <div className="modal-actions">
          <Button className="modal-save" type="submit" onClick={handleSubmit}>
            Save Changes
          </Button>
          <Button className="modal-close" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </form>
    </Modal>
  );
};

EditTransactionModal.propTypes = {
  transaction: TransactionPresenter.shape().isRequired,
  isOpen: PropTypes.bool.isRequired,
  onTransactionUpdate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  cashback: CashbackPresenter.shape({}),
  stores: PropTypes.arrayOf(StorePresenter.shape()),
};

EditTransactionModal.defaultProps = {
  cashback: null,
  stores: [],
};

export default EditTransactionModal;
